import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import { 
    getGlsSkPlacesFetchSuccess, 
    getGlsSkPlacesFetchFailure,
    getGlsSkPlaceByAddressIdFetchSuccess,
    getGlsSkPlaceByAddressIdFetchFailure,
} from './reducer';
import { GlsSkPlacesResType } from '../../types/glsSkPlaces';

const getGlsSkPlacesFetchRequest = async (country: string) => {
    const res = await api('get', `api/secure/shippers/gls/access-points?country=${country}`);
    return res.data;
};

function* getGlsSkPlacesFetch(action: { type: string; payload: string }) {
    try {
        const response: GlsSkPlacesResType = yield call((): any => getGlsSkPlacesFetchRequest(action.payload));

        yield put(getGlsSkPlacesFetchSuccess({ data: response, country: action.payload }));
    } catch (error) {
        yield put(getGlsSkPlacesFetchFailure({ error, noMessage: true }));
    }
}

export function* getGlsSkPlacesFetchWatch() {
    yield takeEvery('glsSkPlaces/getGlsSkPlacesFetch', getGlsSkPlacesFetch);
}

const getGlsSkPlaceByAddressIdFetchRequest = async (addressId: string) => {
    const res = await api('get', `api/secure/shippers/gls/pickup-point/${addressId}`);
    return res.data;
};

function* getGlsSkPlaceByAddressIdFetch(action: { type: string; payload: string }): Generator<any, void, any> {
    try {
        const response: any = yield call((): any => getGlsSkPlaceByAddressIdFetchRequest(action.payload));

        yield put(getGlsSkPlaceByAddressIdFetchSuccess({ country: response.Country, addressId: action.payload }));
    } catch (error) {
        yield put(getGlsSkPlaceByAddressIdFetchFailure({ error, noMessage: true }));
    }
}

export function* getGlsSkPlaceByAddressIdFetchWatch() {
    yield takeEvery('glsSkPlaces/getGlsSkPlaceByAddressIdFetch', getGlsSkPlaceByAddressIdFetch);
}
